module.exports = __webpack_public_path__ + "img/pro_emm_03.057cb261.png";